
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';



@Injectable({
    providedIn: 'root'
  })
export class OrganizationService {

    constructor(
        private http: HttpClient,
        private router: Router
    ) {
    }
    

    listOrganizations(params) {
        return this.http.get(`/api/v1/organizations`, {params: params});

    }
    getOrganization(organizationId) {
        return this.http.get(`/api/v1/organizations/${organizationId}`);
    }


    
}
